import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Analysing.module.scss'
import { LiveHelpButton } from 'components/LiveHelpButton/LiveHelpButton'
import { ProgressStatusCollection, ProgressStatusItem } from 'components/ProgressStatus/ProgressStatusCollection'

export const Analysing = () => {
  return (
    <div className={Styles.wrapper}>
      <img
        src="https://res.cloudinary.com/almanac/image/upload/v1752178836/blaze_assets/hd_icons/stacked-cards.png"
        alt="Loading"
        className={Styles.loadingImage}
      />
      <div className={Styles.content}>
        <Heading level={5}>Reviewing your themes & materials 👀</Heading>
        <ProgressStatusCollection>
          <ProgressStatusItem immediateComplete>Analyzing your themes & topics</ProgressStatusItem>
          <ProgressStatusItem immediateComplete>Proposing campaigns</ProgressStatusItem>
          <ProgressStatusItem>Scheduling</ProgressStatusItem>
        </ProgressStatusCollection>
      </div>
      <LiveHelpButton message="Hello! Can you help me with my autopilot campaigns?" />
    </div>
  )
}
